import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
let defaultLang = window.location.pathname
if (defaultLang === '/') {
  defaultLang = '/ja'
}

let locale = defaultLang.replace(/^\/([^]+).*/i, '$1')
locale = locale.split('/')
switch (locale[0]) {
  case 'en':
    locale[0] = 'en'
    break
  case 'zh-tw':
    locale[0] = 'zh-tw'
    break
  case 'zh-cn':
    locale[0] = 'zh-cn'
    break
  default:
    locale[0] = 'ja'
    break
}

const html = document.documentElement
html.setAttribute('lang', locale[0])

export default new VueI18n({
  locale: locale[0] || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: locale[0] || process.env.VUE_APP_I18N_LOCALE,
  messages: loadLocaleMessages()
})
